import { NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { SpaCommandExecutorFactory } from '../spa-command.contract';

const createCommand: SpaCommandExecutorFactory = injector => {
	const router = injector.get(Router);
	const zone = injector.get(NgZone);

	return function openTask(payload: any) {
		const taskId = payload?.taskId;
		if (!taskId) {
			return console.error(`openTask require option { taskId: number }`);
		}

		const params = {
			...payload,
		};
		delete params.taskId;

		const queryParams = Object.entries(params)
			.map(([param, value]) => `${param}=${value}`)
			.join('&');

		return zone.runTask(() =>
			router.navigate(['/tasks', taskId], {
				queryParams: {
					...params,
				},
			})
		);
	};
};

export default createCommand;
